import React from 'react';
import { DESCRIPTION_INFO, TRANSACTIONS_PAGES } from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import withShipment from '../../withShipment';
import { statusSelector } from '../../redux/selectors/global';
import { clearStatus } from '../../redux/actions/global';
import {
  employeesSelector,
  userInfoSelector,
} from '../../redux/selectors/auth';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormHelperText,
  IconButton,
  TextField,
  Tooltip,
} from '@material-ui/core';
import {
  deleteTransaction,
  getPDFPreview,
  listTransaction,
  resetPdfPreviewData,
  rollOverRequestList,
  rollOverTransaction,
  saveTransaction,
} from '../../redux/actions/ticketOut';
import TransactionTable from './TransactionTable';
import {
  PDFpreviewReadySelector,
  rollOverRequestsSelector,
  transactionSelector,
} from '../../redux/selectors/ticketOut';
import { BACK } from '../reading/masterReading/constants';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import RenderPurchaseOrderPDFPreview from './RenderPurchaseOrderPDFPreview';
import PaymentPopperTransaction from './PaymentPopperTransaction';
import Utils from '../Utils/Utils';
import { GetApp } from '@material-ui/icons';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import { DEFAULT_PDF_ZOOM } from '../global/constants';
import CustomToolbar from '../global/CustomToolbar';
import { getEmployees } from '../../redux/actions/auth';
import RefreshIcon from '@material-ui/icons/Refresh';
import InputAdornment from '@material-ui/core/InputAdornment';
import TransactionCategory from './TransactionCategory';
import SettingsIcon from '@material-ui/icons/Settings';
import { listCategory } from '../../redux/actions/settings';
import { categorySelector } from '../../redux/selectors/settings';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { listAllCustomers } from '../../redux/actions/customer';
import { customersSelector } from '../../redux/selectors/customer';
import PrintIcon from '@mui/icons-material/Print';
import { ROLE_MASTER_ADMIN } from '../settings/ManageUsers/constants';
import InfoIcon from '@material-ui/icons/Info';

class Transaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: TRANSACTIONS_PAGES.TABLE,
      feedbackBarOpen: false,
      error: false,
      transactionId: null,
      amount: '',
      description: '',
      expenseType: null,
      comments: '',
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      requiredList: ['amount', 'description'],
      hideMenu: false,
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: null,
      scale: DEFAULT_PDF_ZOOM,
      selectedEntries: [],
      isSelecting: false,
      isDialogOpen: false,
      selectedCustomerId: null,
      selectedEmployeeId: null,
      nameInput: null,
      isToolbar: false,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
    };
  }

  componentDidMount() {
    const isToolbar = this.props.isToolbar;

    if (isToolbar === true || isToolbar === undefined) {
      this.props.rollOverRequestList({ userId: this.props.user.userId });
    }

    this.setState(
      {
        isToolbar: isToolbar !== false,
      },
      () => {}
    );

    this.props.listAllCustomers({
      locationId: this.props.user.selectedLocationId,
    });
    this.props.listCategory({ locationId: this.props.user.selectedLocationId });

    this.props.listTransaction({
      userId: this.props.userId ? this.props.userId : this.props.user.userId,
      clockId: this.props.clockId,
    });
    this.props.getEmployees({
      locationId: this.props.user.selectedLocationId,
    });
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }

    if (
      !this.arrayEquals(prevProps.PDFpreviewReady, this.props.PDFpreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFpreviewReady,
      });
    }
  }

  handleEmployeeChange = (event, newValue) => {
    this.setState({
      selectedEmployeeId: newValue ? newValue.userId : null,
    });
  };

  // The description Autocomplete normally lists the backend-managed
  // TransactionCategory records from `this.props.categories`. When the
  // Transaction form is opened from Employee Session → Edit Shift
  // Report, we append a synthetic "TRANSFER MONEY" option so a
  // supervisor can record an ad-hoc transfer against that shift. The
  // synthetic option is distinct from the existing "TRANSFER MONEY TO
  // EMPLOYEE" row, which still goes through the pending-transfer
  // accept/decline flow on the backend.
  // Employees eligible for the new "TRANSFER MONEY" description: all
  // users at the location EXCEPT Master Admins, Managers, and Reading
  // Guys. In practice this narrows the picker down to Supervisor /
  // Employee roles, and unlike "transfer money to employee" we do NOT
  // require the target to be currently online/clocked-in.
  getTransferMoneyEmployees = () => {
    const excluded = new Set([
      'ROLE_MASTER_ADMIN',
      'ROLE_MANAGER',
      'ROLE_READING_GUY',
    ]);
    const list = Array.isArray(this.props.employees)
      ? this.props.employees
      : [];
    return list.filter((e) => {
      const auths = Array.isArray(e.authorities)
        ? e.authorities.map((a) =>
            typeof a === 'string' ? a : a?.authority
          )
        : [];
      return !auths.some((a) => excluded.has(a));
    });
  };

  getDescriptionOptions = () => {
    const cats = Array.isArray(this.props.categories)
      ? this.props.categories
      : [];
    if (!this.props.fromEmployeeSession) return cats;
    if (cats.some((c) => c.name?.toUpperCase() === 'TRANSFER MONEY')) {
      return cats;
    }
    return [...cats, { name: 'TRANSFER MONEY', expenseType: null, isGlobal: true }];
  };

  handleCustomerChange = (event, newValue) => {
    this.setState({
      selectedCustomerId: newValue ? newValue.customerId : null,
    });
  };

  setBackMenu = (bool) => {
    this.setState({ hideMenu: bool });
    this.props.listCategory({ locationId: this.props.user.selectedLocationId });
  };

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  clearAmounts = () => {
    this.setState({
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      amount: '',
    });
  };

  handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  // Close dialog function
  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false }, () => {
      this.props.listTransaction({
        userId: this.props.userId ? this.props.userId : this.props.user.userId,
        clockId: this.props.clockId,
      });
    });
  };

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  displaySetting = () => {
    return (
      <TransactionCategory
        setCurrentPage={this.setCurrentPage}
        setBackMenu={this.setBackMenu}
        openFeedbackBar={this.openFeedbackBar}
      />
    );
  };

  handleEditRow = (row) => {
    this.setState(
      {
        transactionId: row.transactionId,
        comments: row.comments,
        amount: row.amount,
        type: row.type,
        description: row.description,
        expenseType: row.expenseType,
        selectedCustomerId: row.selectedCustomerId,
        selectedEmployeeId: row.selectedEmployeeId,
      },
      () => {}
    );
  };

  displayTable = () => {
    return (
      <TransactionTable
        isToolbar={this.state.isToolbar}
        deleteTransaction={this.props.deleteTransaction}
        bankList={this.props.transactions?.bankList}
        expenseList={this.props.transactions?.expenseList}
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
        handleSelectTransaction={this.handleSelectTransaction}
        selectedEntries={this.state.selectedEntries}
        isSelecting={this.state.isSelecting}
        handleEditRow={this.handleEditRow}
        user={this.props.user}
      />
    );
  };

  handleSelectTransaction = (transactionId) => {
    const { selectedEntries } = this.state;
    let index = selectedEntries.indexOf(transactionId);
    if (index === -1) {
      selectedEntries.push(transactionId);
    } else {
      selectedEntries.splice(index, 1);
    }

    const isSelecting = selectedEntries.length > 0;

    this.setState({ selectedEntries, isSelecting });
  };

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case TRANSACTIONS_PAGES.TABLE:
        return this.displayTable();
      case TRANSACTIONS_PAGES.SETTING:
        return this.displaySetting();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  handleNumberChange = (event) => {
    const { name, value } = event.target;

    const reg = /^[0-9\b]+$/;

    if (value === '' || reg.test(value)) {
      this.setState({ [name]: value });
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  refreshTransaction = () => {
    this.props.rollOverRequestList({ userId: this.props.user.userId });
  };

  showPdfErrorMessage = (isFailed) => {
    this.props.resetPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  fetchPdf = async () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    this.props.getPDFPreview(
      {
        userId: this.props.user.userId,
        locationId: this.props.user.selectedLocationId,
        date: getTodayDate,
      },
      this.showPdfErrorMessage
    );
    this.setState({ showPdfViewer: true });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: null });
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.user.firstname} Shift Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  handleRequest = (status, request) => {
    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', response);
      } else {
        this.openFeedbackBar('success', response);
      }
      window.location.reload();
    };

    const data = {
      selectedEmployeeId: this.props.user.userId,
      transactionId: request.transactionId,
      status: status,
      type: request.description.toLowerCase().includes('cash left')
        ? 'cash-left'
        : null,
    };
    this.props.rollOverTransaction(data, callback);
  };

  render() {
    const { amounts, showPdfViewer, pdfData, scale } = this.state;
    let headerButtons;
    headerButtons = [];
    if (showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            if (!this.state.pdfData) return;
            Utils.handlePdfAction(
              this.state.pdfData,
              'print',
              'Shift-report-print.pdf'
            );
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span key="zoom-label" style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else {
      headerButtons.push(
        {
          icon: <LocalAtmIcon />,
          title: 'Set Cash Left',
          handler: () => this.handleOpenDialog(),
        },
        ...(this.props.user?.authority.includes(ROLE_MASTER_ADMIN)
          ? [
              {
                icon: <SettingsIcon />,
                title: 'Add description',
                handler: () => {
                  this.setBackMenu(true);
                  this.setCurrentPage(TRANSACTIONS_PAGES.SETTING, {});
                },
              },
            ]
          : []),
        {
          icon: <VisibilityIcon />,
          title: 'View Report',
          handler: () => this.fetchPdf(),
        },
        {
          icon: <RefreshIcon />,
          title: 'Refresh for rollover requests',
          handler: () => this.refreshTransaction(),
        }
      );
    }

    return (
      <React.Fragment>
        {/*<ErrorFeedbackBar/>*/}
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {!this.state.hideMenu && this.state.isToolbar && (
          <CustomToolbar
            title={`Transaction (${this.props.user.firstname})`}
            createTitle={''}
            backTitle={''}
            headerButtons={headerButtons}
          />
        )}

        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleCloseDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Set Cash Left</DialogTitle>
          <DialogContent>
            <PaymentPopperTransaction
              isMobile={this.state.isMobile}
              employees={this.props.employees}
              userId={this.props.user.userId} // Passing the userId prop
              openFeedbackBar={this.openFeedbackBar} // Passing the feedback bar handler
              handleClosePopper={this.handleCloseDialog} // Close the dialog when save or close
            />
          </DialogContent>
        </Dialog>

        {showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            handleSubmit={this.handleSubmit}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={scale}
          />
        ) : !this.state.hideMenu ? (
          <>
            {this.props.rollOverRequests &&
              this.props.rollOverRequests.length > 0 && (
                <div
                  style={{
                    margin: '16px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '16px',
                    }}
                  >
                    <h3
                      style={{
                        margin: 0,
                        fontSize: '1.2rem',
                        color: '#111827',
                        fontWeight: 'bold',
                      }}
                    >
                      Pending Requests
                    </h3>
                    <span
                      style={{
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        padding: '2px 10px',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                      }}
                    >
                      {this.props.rollOverRequests.length} Pending
                    </span>
                  </div>

                  <div style={{ display: 'grid', gap: '12px' }}>
                    {this.props.rollOverRequests.map((request) => (
                      <div
                        key={request.transactionId}
                        style={{
                          backgroundColor: 'white',
                          padding: '16px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          display: 'flex',
                          flexDirection: 'column',
                          border: '1px solid #e5e7eb',
                          gap: '12px',
                        }}
                      >
                        {/* Top Row: Sender Info & Amount */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                            }}
                          >
                            {/* Simple Avatar Circle */}
                            <div
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: '#e0e7ff',
                                color: '#4338ca',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                              }}
                            >
                              {request.senderName?.charAt(0).toUpperCase() ||
                                '?'}
                            </div>
                            <div>
                              <div
                                style={{
                                  fontSize: '0.75rem',
                                  color: '#6b7280',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.05em',
                                }}
                              >
                                Sent By
                              </div>
                              <div
                                style={{
                                  fontWeight: '700',
                                  color: '#111827',
                                }}
                              >
                                {request.senderName}
                              </div>
                            </div>
                          </div>
                          <div style={{ textAlign: 'right' }}>
                            <div
                              style={{
                                fontSize: '1.2rem',
                                fontWeight: '800',
                                color: '#059669',
                              }}
                            >
                              $
                              {parseFloat(request.amount).toLocaleString(
                                undefined,
                                { minimumFractionDigits: 2 }
                              )}
                            </div>
                          </div>
                        </div>

                        <hr
                          style={{
                            border: '0',
                            borderTop: '1px solid #f3f4f6',
                            margin: '0',
                          }}
                        />

                        {/* Middle Row: Details */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontSize: '0.9rem',
                                color: '#374151',
                                fontWeight: '500',
                              }}
                            >
                              {request.description}
                            </div>
                            <div
                              style={{
                                fontSize: '0.8rem',
                                color: '#9ca3af',
                                marginTop: '2px',
                              }}
                            >
                              {request.date}
                            </div>
                            {request.comments && (
                              <div
                                style={{
                                  fontSize: '0.8rem',
                                  color: '#6b7280',
                                  fontStyle: 'italic',
                                  marginTop: '4px',
                                }}
                              >
                                "{request.comments}"
                              </div>
                            )}
                          </div>

                          {/* Action Buttons */}
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              onClick={() =>
                                this.handleRequest('Reject', request)
                              }
                              style={{
                                backgroundColor: 'white',
                                color: '#dc2626',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                border: '1px solid #fca5a5',
                                fontWeight: '600',
                                cursor: 'pointer',
                              }}
                            >
                              Decline
                            </button>
                            <button
                              onClick={() =>
                                this.handleRequest('Accept', request)
                              }
                              style={{
                                backgroundColor: '#059669',
                                color: 'white',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                border: 'none',
                                fontWeight: '600',
                                cursor: 'pointer',
                                boxShadow: '0 2px 4px rgba(5, 150, 105, 0.2)',
                              }}
                            >
                              Accept
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {this.state.isMobile ? (
              <div
                className="rowSpecMasterTransaction"
                style={{ marginTop: '24px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    marginRight: '16px',
                  }}
                >
                  <Autocomplete
                    className="input-text-field"
                    style={{ width: '100%' }}
                    options={this.getDescriptionOptions()}
                    getOptionLabel={(option) => option.name || ''}
                    // Match the value based on Uppercase for production consistency
                    value={
                      this.state.description
                        ? this.getDescriptionOptions().find(
                            (cat) =>
                              cat.name.toUpperCase() ===
                              this.state.description.toUpperCase()
                          )
                        : null
                    }
                    onChange={(e, value) => {
                      this.setState({
                        description: value ? value.name.toUpperCase() : '',
                        expenseType:
                          value && value.expenseType ? value.expenseType : null,
                        // Removed showInfo: !!value so it stays hidden until clicked
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="description"
                        label="Description"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        required={this.state.requiredList.includes(
                          'description'
                        )}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              <InputAdornment position="end">
                                <Tooltip title="View Info">
                                  <IconButton
                                    size="small"
                                    // Manual toggle only
                                    onClick={() =>
                                      this.setState({
                                        showInfo: !this.state.showInfo,
                                      })
                                    }
                                    color={
                                      this.state.showInfo
                                        ? 'primary'
                                        : 'default'
                                    }
                                    // Optional: disable if no description is selected
                                    disabled={!this.state.description}
                                  >
                                    <InfoIcon fontSize="medium" />
                                  </IconButton>
                                </Tooltip>
                              </InputAdornment>
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />

                  {this.state.showInfo &&
                    this.state.description &&
                    DESCRIPTION_INFO[this.state.description.toUpperCase()] && (
                      <div
                        className="input-text-field"
                        style={{
                          padding: '10px 14px',
                          backgroundColor: 'white',
                          border: '1px solid #1976d2',
                          borderLeft: '5px solid #1976d2',
                          borderRadius: '4px',
                          position: 'relative',
                        }}
                      >
                        <FormHelperText
                          style={{
                            color: '#1976d2',
                            fontSize: '0.85rem',
                            margin: 0,
                            lineHeight: '1.4',
                          }}
                        >
                          <strong>Note:</strong>{' '}
                          {
                            DESCRIPTION_INFO[
                              this.state.description.toUpperCase()
                            ]
                          }
                        </FormHelperText>
                      </div>
                    )}
                </div>

                {(this.state.description.toLowerCase() === 'customer loans' ||
                  this.state.description.toLowerCase() === 'zelle' ||
                  this.state.description.toLowerCase() ===
                    'extra match / lucky' ||
                  this.state.description.toLowerCase() ===
                    'customer pay loans') && (
                  <Autocomplete
                    className="input-text-field"
                    options={this.props.customers}
                    getOptionLabel={(option) =>
                      `${option.firstName} ${option.lastName}`
                    }
                    value={
                      this.state.selectedCustomerId
                        ? this.props.customers.find(
                            (c) =>
                              c.customerId === this.state.selectedCustomerId
                          ) || null
                        : null
                    }
                    onChange={this.handleCustomerChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        name="customer"
                        label="Select Customer"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                    filterOptions={(options, { inputValue }) => {
                      return options.filter(
                        (c) =>
                          c.firstName
                            .toLowerCase()
                            .includes(inputValue.toLowerCase()) ||
                          c.lastName
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                      );
                    }}
                    clearOnEscape
                  />
                )}

                {this.state.description.toLowerCase() ===
                  'manager loan to bank' && (
                  <TextField
                    className="input-text-field"
                    variant="outlined"
                    label="Name"
                    InputLabelProps={{ shrink: true }}
                    name="name"
                    value={this.state.nameInput}
                    onChange={(e) => {
                      const value = e.target.value;
                      const capitalized =
                        value.charAt(0).toUpperCase() + value.slice(1);
                      this.setState({ nameInput: capitalized });
                    }}
                  />
                )}

                {(this.state.description.toLowerCase() ===
                  'employee short payment' ||
                  this.state.description.toLowerCase() ===
                    'transfer money to employee' ||
                  this.state.description.toLowerCase() === 'transfer money') && (
                  <Autocomplete
                    className="input-text-field"
                    options={
                      this.state.description.toLowerCase() === 'transfer money'
                        ? this.getTransferMoneyEmployees()
                        : (Array.isArray(this.props.employees)
                            ? this.props.employees
                            : []
                          ).filter((employee) => employee.isOnline === true)
                    }
                    getOptionLabel={(option) =>
                      [option.firstname, option.lastname]
                        .filter(Boolean)
                        .join(' ')
                    }
                    value={
                      this.state.selectedEmployeeId
                        ? this.props.employees.find(
                            (c) => c.userId === this.state.selectedEmployeeId
                          ) || null
                        : null
                    }
                    onChange={this.handleEmployeeChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        name="employee"
                        label="Select Employee"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                    filterOptions={(options, { inputValue }) => {
                      return options.filter((c) => {
                        const fullName = [c.firstname, c.lastname]
                          .filter(Boolean)
                          .join(' ')
                          .toLowerCase();
                        return fullName.includes(inputValue.toLowerCase());
                      });
                    }}
                    clearOnEscape
                  />
                )}

                {this.state.description.toLowerCase() === 'zelle' && (
                  <Autocomplete
                    className="input-text-field"
                    options={
                      Array.isArray(this.props.employees)
                        ? this.props.employees
                        : [this.props.employees]
                    }
                    getOptionLabel={(option) =>
                      [option.firstname, option.lastname]
                        .filter(Boolean)
                        .join(' ')
                    }
                    value={
                      this.state.selectedEmployeeId
                        ? this.props.employees.find(
                            (c) => c.userId === this.state.selectedEmployeeId
                          ) || null
                        : null
                    }
                    onChange={this.handleEmployeeChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        name="employee"
                        label="Funds deposited to account of"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                    filterOptions={(options, { inputValue }) => {
                      return options.filter((c) => {
                        const fullName = [c.firstname, c.lastname]
                          .filter(Boolean)
                          .join(' ')
                          .toLowerCase();
                        return fullName.includes(inputValue.toLowerCase());
                      });
                    }}
                    clearOnEscape
                  />
                )}

                <TextField
                  className="input-text-field"
                  variant="outlined"
                  label="Amount"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  name="amount"
                  value={this.state.amount}
                  onChange={this.handleNumberChange}
                  required={this.state.requiredList.includes('amount')}
                />

                <TextField
                  variant="outlined"
                  label="Comments"
                  className="single-line-field"
                  InputLabelProps={{ shrink: true }}
                  name="comments"
                  value={this.state.comments}
                  onChange={this.handleChange}
                  multiline
                  minRows={2}
                  maxRows={6}
                />

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginLeft: '10px',
                    marginRight: '10px',
                    marginTop: '10px',
                  }}
                >
                  <Button
                    style={{
                      height: '55px',
                      flex: 1,
                      marginRight: '10px',
                      borderRadius: '0',
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const callback = (error, response) => {
                        if (error) {
                          this.openFeedbackBar('error', response);
                        } else {
                          this.openFeedbackBar('success', response);
                        }
                        this.setState({
                          transactionId: null,
                          amount: '',
                          description: '',
                          comments: '',
                          nameInput: null,
                          expenseType: null,
                          selectedCustomerId: null,
                          selectedEmployeeId: null,
                        });
                        this.clearAmounts();
                      };
                      this.props.saveTransaction(
                        {
                          transactionId: this.state.transactionId,
                          amount: this.state.amount,
                          description: this.state.description,
                          comments: this.state.comments,
                          userId: this.props.userId
                            ? this.props.userId
                            : this.props.user.userId,
                          locationId: this.props.user.selectedLocationId,
                          selectedCustomerId: this.state.selectedCustomerId,
                          selectedEmployeeId: this.state.selectedEmployeeId,
                          nameInput: this.state.nameInput,
                          expenseType: this.state.expenseType,
                          modifyUserId: this.props.userId
                            ? this.props.user.userId
                            : null,
                          clockId: this.props.clockId,
                          type: 'bank',
                          amounts: amounts,
                        },
                        callback
                      );
                    }}
                    disabled={(() => {
                      const desc = this.state.description?.toLowerCase();
                      const amount = this.state.amount;

                      if (desc === 'customer loans') {
                        return true;
                      }

                      if (desc === 'extra match / lucky') {
                        return true;
                      }

                      if (desc === 'customer pay loans') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedCustomerId
                        );
                      }

                      if (
                        desc === 'employee payroll' ||
                        desc === 'transfer money to employee'
                      ) {
                        return true;
                      }

                      if (desc === 'transfer money') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId
                        );
                      }

                      if (desc === 'employee short payment') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId
                        );
                      }

                      if (desc === 'zelle') {
                        return !(
                          amount &&
                          this.state.description &&
                          !this.state.selectedEmployeeId &&
                          !this.state.selectedCustomerId
                        );
                      }

                      if (desc === 'manager loan to bank') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.nameInput
                        );
                      }

                      // Case 3: Any other description — just needs amount & description
                      return !(amount && this.state.description);
                    })()}
                  >
                    {this.state.transactionId ? 'UPDATE BANK' : 'ADD BANK'}
                  </Button>

                  <Button
                    style={{ height: '55px', flex: 1, borderRadius: '0' }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const callback = (error, response) => {
                        if (error) {
                          this.openFeedbackBar('error', response);
                        } else {
                          this.openFeedbackBar('success', response);
                        }
                        this.setState({
                          transactionId: null,
                          amount: '',
                          description: '',
                          comments: '',
                          expenseType: null,
                          selectedCustomerId: null,
                          selectedEmployeeId: null,
                        });

                        this.clearAmounts();
                      };
                      this.props.saveTransaction(
                        {
                          transactionId: this.state.transactionId,
                          amount: this.state.amount,
                          description: this.state.description,
                          comments: this.state.comments,
                          userId: this.props.userId
                            ? this.props.userId
                            : this.props.user.userId,
                          locationId: this.props.user.selectedLocationId,
                          selectedCustomerId: this.state.selectedCustomerId,
                          selectedEmployeeId: this.state.selectedEmployeeId,
                          modifyUserId: this.props.userId
                            ? this.props.user.userId
                            : null,
                          clockId: this.props.clockId,
                          nameInput: this.state.nameInput,
                          expenseType: this.state.expenseType,
                          type: 'expense',
                          amounts: amounts,
                        },
                        callback
                      );
                    }}
                    disabled={(() => {
                      const desc = this.state.description?.toLowerCase();
                      const amount = this.state.amount;

                      if (desc === 'customer loans') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedCustomerId
                        );
                      }

                      if (
                        desc === 'transfer money to employee' ||
                        desc === 'transfer money'
                      ) {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId
                        );
                      }

                      if (desc === 'extra match / lucky') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedCustomerId
                        );
                      }

                      if (desc === 'customer pay loans') {
                        return true;
                      }

                      if (desc === 'zelle') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId &&
                          this.state.selectedCustomerId
                        );
                      }

                      if (desc === 'manager loan to bank') {
                        return true;
                      }

                      if (desc === 'employee short payment') {
                        return true;
                      }

                      // Case 3: Any other description — just needs amount & description
                      return !(amount && this.state.description);
                    })()}
                  >
                    {this.state.transactionId
                      ? 'UPDATE EXPENSE'
                      : 'ADD EXPENSE'}
                  </Button>
                </div>
              </div>
            ) : (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '16px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '50%',
                      marginRight: '16px',
                    }}
                  >
                    <Autocomplete
                      className="input-text-field"
                      style={{ width: '100%' }}
                      options={this.getDescriptionOptions()}
                      getOptionLabel={(option) => option.name || ''}
                      // Match the value based on Uppercase for production consistency
                      value={
                        this.state.description
                          ? this.getDescriptionOptions().find(
                              (cat) =>
                                cat.name.toUpperCase() ===
                                this.state.description.toUpperCase()
                            )
                          : null
                      }
                      onChange={(e, value) => {
                        this.setState({
                          description: value ? value.name.toUpperCase() : '',
                          expenseType:
                            value && value.expenseType
                              ? value.expenseType
                              : null,
                          // Removed showInfo: !!value so it stays hidden until clicked
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="description"
                          label="Description"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          required={this.state.requiredList.includes(
                            'description'
                          )}
                        />
                      )}
                    />

                    {this.state.showInfo &&
                      this.state.description &&
                      DESCRIPTION_INFO[
                        this.state.description.toUpperCase()
                      ] && (
                        <div
                          style={{
                            width: '100%',
                            marginLeft: '10px',
                            marginTop: '0px',
                            marginBottom: '8px',
                            padding: '10px 14px',
                            backgroundColor: 'white',
                            border: '1px solid #1976d2',
                            borderLeft: '5px solid #1976d2',
                            borderRadius: '4px',
                            position: 'relative',
                          }}
                        >
                          <FormHelperText
                            style={{
                              color: '#1976d2',
                              fontSize: '0.85rem',
                              margin: 0,
                              lineHeight: '1.4',
                            }}
                          >
                            <strong>Note:</strong>{' '}
                            {
                              DESCRIPTION_INFO[
                                this.state.description.toUpperCase()
                              ]
                            }
                          </FormHelperText>
                        </div>
                      )}
                  </div>

                  <div
                    style={{
                      marginTop: '20px',
                    }}
                  >
                    <IconButton
                      size="small"
                      onClick={() =>
                        this.setState({
                          showInfo: !this.state.showInfo,
                        })
                      }
                      color={this.state.showInfo ? 'primary' : 'default'}
                      disabled={!this.state.description}
                    >
                      <InfoIcon fontSize="medium" />
                    </IconButton>
                  </div>

                  {(this.state.description.toLowerCase() === 'customer loans' ||
                    this.state.description.toLowerCase() === 'zelle' ||
                    this.state.description.toLowerCase() ===
                      'extra match / lucky' ||
                    this.state.description.toLowerCase() ===
                      'customer pay loans') && (
                    <Autocomplete
                      style={{ marginTop: '10px' }}
                      className="form-input"
                      options={this.props.customers}
                      getOptionLabel={(option) =>
                        `${option.firstName} ${option.lastName}`
                      }
                      value={
                        this.state.selectedCustomerId
                          ? this.props.customers.find(
                              (c) =>
                                c.customerId === this.state.selectedCustomerId
                            ) || null
                          : null
                      }
                      onChange={this.handleCustomerChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          name="customer"
                          label="Select Customer"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      filterOptions={(options, { inputValue }) => {
                        return options.filter(
                          (c) =>
                            c.firstName
                              .toLowerCase()
                              .includes(inputValue.toLowerCase()) ||
                            c.lastName
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                        );
                      }}
                      clearOnEscape
                    />
                  )}

                  {this.state.description.toLowerCase() ===
                    'manager loan to bank' && (
                    <TextField
                      style={{ width: '50%' }}
                      className="input-text-field"
                      variant="outlined"
                      label="Name"
                      InputLabelProps={{ shrink: true }}
                      name="name"
                      value={this.state.nameInput}
                      onChange={(e) => {
                        const value = e.target.value;
                        const capitalized =
                          value.charAt(0).toUpperCase() + value.slice(1);
                        this.setState({ nameInput: capitalized });
                      }}
                    />
                  )}

                  {(this.state.description.toLowerCase() ===
                    'employee short payment' ||
                    this.state.description.toLowerCase() ===
                      'transfer money to employee' ||
                    this.state.description.toLowerCase() ===
                      'transfer money') && (
                    <Autocomplete
                      style={{ marginTop: '10px', marginLeft: '10px' }}
                      className="form-input"
                      options={
                        this.state.description.toLowerCase() ===
                        'transfer money'
                          ? this.getTransferMoneyEmployees()
                          : (Array.isArray(this.props.employees)
                              ? this.props.employees
                              : []
                            ).filter((employee) => employee.isOnline === true)
                      }
                      getOptionLabel={(option) =>
                        [option.firstname, option.lastname]
                          .filter(Boolean)
                          .join(' ')
                      }
                      value={
                        this.state.selectedEmployeeId
                          ? this.props.employees.find(
                              (c) => c.userId === this.state.selectedEmployeeId
                            ) || null
                          : null
                      }
                      onChange={this.handleEmployeeChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          name="employee"
                          label="Select Employee"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      filterOptions={(options, { inputValue }) => {
                        return options.filter((c) => {
                          const fullName = [c.firstname, c.lastname]
                            .filter(Boolean)
                            .join(' ')
                            .toLowerCase();
                          return fullName.includes(inputValue.toLowerCase());
                        });
                      }}
                      clearOnEscape
                    />
                  )}

                  {this.state.description.toLowerCase() === 'zelle' && (
                    <Autocomplete
                      style={{ marginTop: '10px', marginLeft: '10px' }}
                      className="form-input"
                      options={
                        Array.isArray(this.props.employees)
                          ? this.props.employees
                          : [this.props.employees]
                      }
                      getOptionLabel={(option) =>
                        [option.firstname, option.lastname]
                          .filter(Boolean)
                          .join(' ')
                      }
                      value={
                        this.state.selectedEmployeeId
                          ? this.props.employees.find(
                              (c) => c.userId === this.state.selectedEmployeeId
                            ) || null
                          : null
                      }
                      onChange={this.handleEmployeeChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          name="employee"
                          label="Funds deposited to account of"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      filterOptions={(options, { inputValue }) => {
                        return options.filter((c) => {
                          const fullName = [c.firstname, c.lastname]
                            .filter(Boolean)
                            .join(' ')
                            .toLowerCase();
                          return fullName.includes(inputValue.toLowerCase());
                        });
                      }}
                      clearOnEscape
                    />
                  )}

                  <TextField
                    style={{ width: '50%' }}
                    className="input-text-field"
                    variant="outlined"
                    label="Amount"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                    name="amount"
                    value={this.state.amount}
                    onChange={this.handleNumberChange}
                    required={this.state.requiredList.includes('amount')}
                  />
                </div>

                <div style={{ marginRight: '20px' }}>
                  <TextField
                    style={{ width: '100%' }}
                    variant="outlined"
                    label="Comments"
                    className="single-line-field"
                    InputLabelProps={{ shrink: true }}
                    name="comments"
                    value={this.state.comments}
                    onChange={this.handleChange}
                    multiline
                    minRows={2}
                    maxRows={6}
                  />
                </div>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Button
                    style={{
                      height: '55px',
                      flex: 1,
                      marginRight: '10px',
                      borderRadius: '0',
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const callback = (error, response) => {
                        if (error) {
                          this.openFeedbackBar('error', response);
                        } else {
                          this.openFeedbackBar('success', response);
                        }
                        this.setState({
                          transactionId: null,
                          amount: '',
                          description: '',
                          comments: '',
                          nameInput: null,
                          expenseType: null,
                          selectedCustomerId: null,
                          selectedEmployeeId: null,
                        });
                        this.clearAmounts();
                      };
                      this.props.saveTransaction(
                        {
                          transactionId: this.state.transactionId,
                          amount: this.state.amount,
                          description: this.state.description,
                          comments: this.state.comments,
                          userId: this.props.userId
                            ? this.props.userId
                            : this.props.user.userId,
                          locationId: this.props.user.selectedLocationId,
                          selectedCustomerId: this.state.selectedCustomerId,
                          selectedEmployeeId: this.state.selectedEmployeeId,
                          nameInput: this.state.nameInput,
                          expenseType: this.state.expenseType,
                          modifyUserId: this.props.userId
                            ? this.props.user.userId
                            : null,
                          clockId: this.props.clockId,
                          type: 'bank',
                          amounts: amounts,
                        },
                        callback
                      );
                    }}
                    disabled={(() => {
                      const desc = this.state.description?.toLowerCase();
                      const amount = this.state.amount;

                      // Case 1: LOAN — needs amount, description, and selectedCustomerId
                      if (
                        desc === 'customer loans' ||
                        desc === 'extra match / lucky'
                      ) {
                        return true;
                      }

                      if (desc === 'customer pay loans') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedCustomerId
                        );
                      }

                      if (
                        desc === 'employee payroll' ||
                        desc === 'transfer money to employee'
                      ) {
                        return true;
                      }

                      if (desc === 'transfer money') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId
                        );
                      }

                      if (desc === 'employee short payment') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId
                        );
                      }

                      if (desc === 'zelle') {
                        return !(
                          amount &&
                          this.state.description &&
                          !this.state.selectedEmployeeId &&
                          !this.state.selectedCustomerId
                        );
                      }

                      if (desc === 'manager loan to bank') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.nameInput
                        );
                      }

                      // Case 3: Any other description — just needs amount & description
                      return !(amount && this.state.description);
                    })()}
                  >
                    {this.state.transactionId ? 'UPDATE BANK' : 'ADD BANK'}
                  </Button>

                  <Button
                    style={{ height: '55px', flex: 1, borderRadius: '0' }}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const callback = (error, response) => {
                        if (error) {
                          this.openFeedbackBar('error', response);
                        } else {
                          this.openFeedbackBar('success', response);
                        }
                        this.setState({
                          transactionId: null,
                          amount: '',
                          description: '',
                          comments: '',
                          expenseType: null,
                          selectedCustomerId: null,
                          selectedEmployeeId: null,
                        });

                        this.clearAmounts();
                      };
                      this.props.saveTransaction(
                        {
                          transactionId: this.state.transactionId,
                          amount: this.state.amount,
                          description: this.state.description,
                          comments: this.state.comments,
                          userId: this.props.userId
                            ? this.props.userId
                            : this.props.user.userId,
                          locationId: this.props.user.selectedLocationId,
                          selectedCustomerId: this.state.selectedCustomerId,
                          selectedEmployeeId: this.state.selectedEmployeeId,
                          expenseType: this.state.expenseType,
                          nameInput: this.state.nameInput,
                          modifyUserId: this.props.userId
                            ? this.props.user.userId
                            : null,
                          clockId: this.props.clockId,
                          type: 'expense',
                          amounts: amounts,
                        },
                        callback
                      );
                    }}
                    disabled={(() => {
                      const desc = this.state.description?.toLowerCase();
                      const amount = this.state.amount;

                      if (
                        desc === 'transfer money to employee' ||
                        desc === 'transfer money'
                      ) {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId
                        );
                      }

                      if (
                        desc === 'customer loans' ||
                        desc === 'extra match / lucky'
                      ) {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedCustomerId
                        );
                      }

                      if (desc === 'customer pay loans') {
                        return true;
                      }

                      if (desc === 'zelle') {
                        return !(
                          amount &&
                          this.state.description &&
                          this.state.selectedEmployeeId &&
                          this.state.selectedCustomerId
                        );
                      }

                      if (desc === 'manager loan to bank') {
                        return true;
                      }

                      if (desc === 'employee short payment') {
                        return true;
                      }

                      // Case 3: Any other description — just needs amount & description
                      return !(amount && this.state.description);
                    })()}
                  >
                    {this.state.transactionId
                      ? 'UPDATE EXPENSE'
                      : 'ADD EXPENSE'}
                  </Button>
                </div>
              </>
            )}

            {this.displayCurrentPage()}
          </>
        ) : (
          this.displayCurrentPage()
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  // employees: usersSelector(state),
  employees: employeesSelector(state),
  user: userInfoSelector(state),
  transactions: transactionSelector(state),
  PDFpreviewReady: PDFpreviewReadySelector(state),
  rollOverRequests: rollOverRequestsSelector(state),
  categories: categorySelector(state),
  customers: customersSelector(state),
});

const actionCreators = {
  clearStatus,
  listTransaction,
  deleteTransaction,
  saveTransaction,
  getPDFPreview,
  resetPdfPreviewData,
  rollOverRequestList,
  rollOverTransaction,
  listCategory,
  listAllCustomers,
  getEmployees,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  Transaction
);
